import styled from '@emotion/styled';
import styleService from '@nykaa/deals-utils/styles';
import { getTagPosition } from '../BannerV2/css';
const { getPaddingStyles, getBKGStyles, getBorderStyles, getFontStyles, getIndividualBorderRadius, getMarginStyles, addAlpha, setVisibility, getIcon, } = styleService.utils;
export const UnitWrapper = styled.div `
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ unitBkg }) => getBKGStyles(unitBkg)};
  border-radius: ${({ cornerRadius }) => cornerRadius === null || cornerRadius === void 0 ? void 0 : cornerRadius.web};
  ${({ border }) => border && getBorderStyles(border)};
  cursor: pointer;
  .row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-count: 3;
    column-gap: ${({ interItem }) => interItem === null || interItem === void 0 ? void 0 : interItem.web};
  }
  .flexible-row {
    flex: 1 1 auto;
  }
  .column {
    display: flex;
    flex-direction: column;
    position: relative;
    .image-callout {
      position: absolute;
      bottom: 0;
    }
  }
  .order-left-right { 
    order: ${({ imageAlignment }) => (imageAlignment === 'left' ? 1 : 2)}
  }
  .unit-tag-order { 
    order: ${({ imageAlignment }) => (imageAlignment === 'left' ? 2 : 1)}
  }
  .trailingicon-order { 
    order: 3;
  }
  .center {
    justify-content: center;
  }
  ${({ visible }) => setVisibility(visible)};
`;
export const ImageArea = styled.div `
  position: relative;
  overflow: hidden;
  width: ${({ imageSize }) => imageSize === null || imageSize === void 0 ? void 0 : imageSize.web};
  height: ${({ bannerHeight }) => `${bannerHeight}px`};
  ${({ individualCornerRadius }) => getIndividualBorderRadius(individualCornerRadius)};
  .image-wrapper {
    min-height: ${({ bannerHeight }) => `${bannerHeight}px`} !important;
  }
  img {
    background-size: cover;
    ${({ individualCornerRadius }) => getIndividualBorderRadius(individualCornerRadius)};
    min-height: ${({ bannerHeight }) => `${bannerHeight}px`} !important;
  }
  .image-callout {
    bottom: 0;
    position: absolute;
  }

  .outline-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: inherit;
    height: inherit;
    ${({ individualCornerRadius }) => getIndividualBorderRadius(individualCornerRadius)};
    outline: ${({ border }) => `${border.width.web}  solid ${addAlpha(border.color, border.alpha)}`};
    outline-offset: ${({ border }) => `-${border.width.web}`};
  }
  ${({ visible }) => setVisibility(visible)};
`;
export const UnitTitle = styled.div `
  ${({ padding, unitTitlePaddingTop }) => unitTitlePaddingTop && getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  ${({ visible }) => setVisibility(visible)};
  -webkit-line-clamp: ${({ text }) => { var _a; return (_a = text === null || text === void 0 ? void 0 : text.maxLines) === null || _a === void 0 ? void 0 : _a.web; }};
  -webkit-box-orient: vertical;
`;
export const UnitDescription = styled.div `
  ${({ padding, unitDescriptionPaddingTop }) => unitDescriptionPaddingTop && getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  ${({ visible }) => setVisibility(visible)};
  -webkit-line-clamp: ${({ text }) => { var _a; return (_a = text === null || text === void 0 ? void 0 : text.maxLines) === null || _a === void 0 ? void 0 : _a.web; }};
  -webkit-box-orient: vertical;
`;
export const ImageCallout = styled.div `
  width: fill-available;
  position: relative;
  ${({ background }) => getBKGStyles(background)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ border }) => getBorderStyles(border)};
  border-radius: ${({ cornerRadius }) => cornerRadius === null || cornerRadius === void 0 ? void 0 : cornerRadius.web};
  ${({ margin }) => getMarginStyles(margin)};
  ${({ text }) => getFontStyles(text)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box !important;
  -webkit-line-clamp: ${({ text }) => { var _a; return (_a = text === null || text === void 0 ? void 0 : text.maxLines) === null || _a === void 0 ? void 0 : _a.web; }};
  -webkit-box-orient: vertical;
  ${({ visible }) => setVisibility(visible)};
`;
export const UnitTag = styled.div `
${({ visible }) => setVisibility(visible)};
  .tag-text-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: fill-available;
    ${({ tagPosition }) => getTagPosition(tagPosition)};
  }
  .tag-text-visible {
    display: none;
  }
  .tag-type-text {
    ${({ background }) => getBKGStyles(background)};
    ${({ padding }) => getPaddingStyles(padding)};
    ${({ text }) => getFontStyles(text)};
    ${({ border }) => getBorderStyles(border)};
    border-radius: ${({ cornerRadius }) => cornerRadius.web};
    .tag-text,
    .color-tag {
      float: left;
      ${({ timerAlignment }) => timerAlignment === 'right' && 'float: left;'};
      ${({ timerAlignment }) => timerAlignment === 'left' && 'float: right;'};
      display: -webkit-box;
      -webkit-line-clamp: ${({ text }) => text.maxLines.web};
      -webkit-box-orient: vertical;
      overflow: hidden;
      ${({ text }) => getFontStyles(text)};
    }
    .tag-timer-text {
      ${({ textTimer }) => getFontStyles(textTimer)};
      min-width: 48px;
      padding: 0px 1px;
      display: -webkit-box;
      -webkit-line-clamp: ${({ textTimer }) => textTimer.maxLines.web};
      -webkit-box-orient: vertical;
      overflow: hidden;
      padding-left: ${({ interItemPadding, timerAlignment }) => timerAlignment === 'right' && interItemPadding.web};
      padding-right: ${({ interItemPadding, timerAlignment }) => timerAlignment === 'left' && interItemPadding.web};
    }
  }
  .tag-type-text.empty {
    display: none;
  }
`;
export const TrailingIcon = styled.div `
  ${({ visible }) => setVisibility(visible)};
  background-color: ${({ iconColor }) => iconColor};
  ${({ iconType }) => getIcon(iconType)};
  display: block;
  width: 24px;
  height: 24px;
`;
